(function () {
  // Allowlist-based HTML sanitizer — only permits safe formatting tags
  function sanitizeHtml(dirty) {
    var allowed = { p: [], strong: [], em: [], ul: [], ol: [], li: [], br: [], b: [], i: [] };
    var div = document.createElement('div');
    div.innerHTML = dirty;
    function clean(node) {
      for (var i = node.childNodes.length - 1; i >= 0; i--) {
        var child = node.childNodes[i];
        if (child.nodeType === 3) continue; // text node — keep
        if (child.nodeType === 1) {
          var tag = child.tagName.toLowerCase();
          if (allowed[tag] !== undefined) {
            // Remove all attributes (prevent onclick, style injections etc.)
            while (child.attributes.length > 0) child.removeAttribute(child.attributes[0].name);
            clean(child);
          } else {
            // Replace disallowed element with its text content
            var text = document.createTextNode(child.textContent);
            node.replaceChild(text, child);
          }
        } else {
          node.removeChild(child);
        }
      }
    }
    clean(div);
    return div.innerHTML;
  }

  function init() {
    var descEl = document.querySelector('[data-colour-description]');
    if (!descEl) return;
    var productId = descEl.dataset.productId;
    var jsonEl = document.querySelector('[data-colour-description-json="' + productId + '"]');
    if (!jsonEl) return;

    var descriptions;
    try {
      descriptions = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!descriptions || typeof descriptions !== 'object') return;

    function applyForVariantId(variantId) {
      var html = descriptions[variantId];
      if (html) {
        descEl.innerHTML = sanitizeHtml(html);
      }
    }

    var initialInput = document.querySelector('input[name="id"]');
    if (initialInput && initialInput.value) {
      applyForVariantId(initialInput.value);
    }

    if (!window.MinimogEvents || typeof window.MinimogEvents.subscribe !== 'function') return;

    window.MinimogEvents.subscribe(productId + '__VARIANT_CHANGE', function (variant) {
      if (!variant) return;
      applyForVariantId(variant.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
